import React from 'react';


function DeclarationBadgeUsagePolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Mark and Badge Usage Policy</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Authorization</h2>
            <p className="leading-relaxed">
              The use of AASC marks, logos, and badges is a privilege granted solely to operators with active, verified status in the Public Registry. Unauthorized use constitutes trademark infringement and a violation of these terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Permitted Usage</h2>
            <p className="leading-relaxed">
              Authorized operators may display the specific badge corresponding to their verified status on websites, marketing materials, and proposals. The badge must remain linked to the operator's profile in the Public Registry for verification.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Integrity of Representation</h2>
            <p className="leading-relaxed">
              Operators must not alter the appearance of the marks. They must not use the marks in a manner that implies AASC endorsement of specific political views, social causes, or unrelated products.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3.5 Prohibited Claims</h2>
            <p className="leading-relaxed mb-4">
              Declared organizations are strictly prohibited from making the following claims in association with the AASC mark:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-red-700 bg-red-50 p-4 border border-red-200 rounded-sm">
              <li>That the AASC "guarantees" the accuracy of their AI agents.</li>
              <li>That the declaration provides legal immunity from AI liability.</li>
              <li>That the AASC has reviewed the operator's source code or model weights.</li>
              <li>That the AASC is a government agency or regulator.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Revocation of Rights</h2>
            <p className="leading-relaxed">
              The right to use AASC marks terminates immediately upon the suspension, revocation, or expiration of an operator's status. Operators must remove all marks from public display within 30 days of termination.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default DeclarationBadgeUsagePolicy;